import React from 'react'

import { UIBottomSheet, UIButton, UIFlex, UISpacing, UIText } from 'components'

import { TErrorBottomsheetProps } from './types'

export const ErrorBottomsheet = ({ title, description, onClose }: TErrorBottomsheetProps) => (
  <UIBottomSheet onClose={onClose}>
    <UIFlex direction="column" alignItems="normal">
      <UIText variant="headline-h3" semiBold>
        {title}
      </UIText>
      <UISpacing mb="sm" />
      <UIText variant="body-3">{description}</UIText>
      <UISpacing mb="lg" />
      <UIButton onClick={onClose}>Entendi</UIButton>
    </UIFlex>
  </UIBottomSheet>
)
